module.exports = __webpack_public_path__ + "img/BRCA1_NK.fc0793f1.png";